import { endsWith, get, prop } from 'lodash/fp'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

import { RadioButtonGroup } from 'common-components'
import { withModalToggle } from 'lib/with-hoc'
import { getToggles } from 'quick-quote/feature-toggles'

import { setAppValue } from '../../../apps/actions'

import { _Dialog } from './_Dialog'

const Component = styled(({ ...props }) => {
  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    if (endsWith(props.subpage, history.location.pathname)) {
      props?.toggleModal?.()
    }
  }, [])

  useEffect(() => {
    if (
      (props?.isModalOpen && !endsWith(props?.subpage, history.location.pathname)) ||
      (!props?.isModalOpen && endsWith(props?.subpage, history.location.pathname))
    ) {
      props?.toggleModal?.()
    }

    if (
      getToggles().ENABLE_CYBERSOURCE_RETRY &&
      props?.isModalOpen &&
      props?.cybsRetryUntilCancel &&
      props?.subpage === 'payment'
    ) {
      dispatch(setAppValue('cybsRetryUntilCancel', false))
      props?.toggleModal?.()
    }
  })

  const _toggleModal = () => {
    const subpage = props.subpage
    if (endsWith(subpage, history.location.pathname)) {
      history.replace(history.location.pathname.replace(`/${subpage}`, ''))
    } else {
      history.push(`${history.location.pathname}/${subpage}`)
    }
    props?.toggleModal?.()
  }

  const _onChange = (value, index) => {
    const selectedOption = props?.options[index]
    const openDialog = selectedOption.openDialog || false
    props?.setValue?.(props?.options[index])
    props?.onChange?.({ value, index, dispatch })
    if (openDialog) {
      if (getToggles().ENABLE_CYBERSOURCE_RETRY && props?.subpage === 'payment' && props?.title === 'ชำระเบี้ยงวดแรก') {
        dispatch({ type: 'START_CYBS_CHECK_RETRY' })
      }
      _toggleModal()
    }
  }

  return (
    <div>
      <RadioButtonGroup {...props} value={props?.value} onChange={_onChange} />
      {props.sections && (
        <_Dialog
          {...props}
          sections={props?.sections}
          toggleModal={() => {
            if (endsWith(props?.subpage, history.location.pathname)) {
              history.replace(history.location.pathname.replace(`/${props?.subpage}`, ''))
            } else {
              history.push(`${history.location.pathname}/${props?.subpage}`)
            }
            props?.toggleModal?.()
          }}
          isModalOpen={props?.isModalOpen}
          subpage={props?.subpage}
          customButtons={props?.customButtons}
          okButton={props?.okButton}
          remoteSelling={props?.remoteSelling}
        />
      )}
    </div>
  )
})`
  .modal-header {
    .modal-title {
      flex-direction: row;
      display: flex;
    }
    .icon,
    .btn-left {
      z-index: 999;
      cursor: pointer;
      height: 40px;
    }
    span {
      margin-left: -28px;
      flex: 1 1 auto;
    }
  }
  .modal-footer {
    justify-content: space-between;
  }
`

export default (hoc) => hoc(withModalToggle(Component))
